import { render, staticRenderFns } from "./mainIndex.vue?vue&type=template&id=6249db3c&scoped=true&"
import script from "./mainIndex.vue?vue&type=script&lang=js&"
export * from "./mainIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249db3c",
  null
  
)

export default component.exports